import React from "react";
import { useLocation, useParams } from "react-router";
import { LeadsListView } from "../../components/LeadsListView";

/**
 * Gen admin: same leads list the exhibitor sees («Вас сканировали» / «Вы сканировали»).
 * Paths: …/leads (inbound) · …/you-scanned (outbound).
 */
export function AdminCompanyLeadsPage() {
  const { id, companyId } = useParams<{ id: string; companyId: string }>();
  const { pathname } = useLocation();
  const direction = pathname.includes("/you-scanned") ? "outbound" : "inbound";

  if (!id || !companyId) {
    return <div className="p-6 text-gray-500 text-[14px]">Компания не найдена</div>;
  }

  const basePath =
    direction === "outbound"
      ? `/events/${id}/exhibitors/${companyId}/you-scanned`
      : `/events/${id}/exhibitors/${companyId}/leads`;

  return (
    <LeadsListView
      eventId={id}
      companyId={companyId}
      basePath={basePath}
      audience="admin"
      showBack
      backTo={`/events/${id}/exhibitors/${companyId}`}
      direction={direction}
      title={direction === "outbound" ? "Вы сканировали" : "Вас сканировали"}
      subtitle={
        direction === "outbound"
          ? "Как в кабинете экспонента: кого стенд отсканировал"
          : "Как в кабинете экспонента: кто сканировал стенд / бейджи"
      }
    />
  );
}
